import { AppState } from '@chegg-wt/core/state'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import React, { useRef } from 'react'
import { connect } from 'react-redux'
import { ProjectTypeKeys } from '@chegg-wt/core/constants/projectTypeKey'
import { useOnClickOutside } from '@chegg-wt/core/hooks/useOnClickOutside'
import { useToggle } from '@chegg-wt/core/hooks/useToggle'
import { setFolderId, fetchFolderProjects } from '@chegg-wt/core/state/folders/actions'
import { setProjectFilter } from '@chegg-wt/core/state/projects/actions'
import { isFolderSelectedSelector } from '@chegg-wt/core/state/folders/selectors'
import { FoldersListItemProps } from './types'
import * as Styled from './styled'

function getIconUrl(isSelected: boolean, isPublic: boolean): string {
  const prefix = isPublic ? 'public-' : ''
  const suffix = isSelected ? '-solid' : ''
  return publicAssetUrl(`${prefix}folder${suffix}.svg`)
}

export const FoldersListItem: React.FC<FoldersListItemProps> = ({
  index,
  folderId,
  name,
  isPublic,
  updateSelection,
  listFolderProjects,
  isSelected,
  setProjectFilter,
}) => {
  const {
    value: isFolderSettingsVisible,
    toggle: toggleFolderSettings,
    off: closeFolderSettings,
  } = useToggle()
  const settingsMenu = useRef<HTMLLIElement>()
  useOnClickOutside(settingsMenu, closeFolderSettings)
  return (
    <Styled.FoldersListItem
      data-selected={isSelected || null}
      ref={settingsMenu}
      data-test="folders-list-item"
    >
      {/* TODO: Replace ClickOutside with something that keeps track when focus is lost */}
      <Styled.FoldersListAction
        type="button"
        onClick={() => {
          updateSelection(folderId)
          listFolderProjects(folderId)
          setProjectFilter(ProjectTypeKeys.DEFAULT)
        }}
        aria-pressed={isSelected}
        data-test={`list-folder-projects-${index}`}
        title={name}
      >
        <Styled.Icon iconSize="20px" icon={getIconUrl(isSelected, isPublic)} />
        <Styled.Label>{name}</Styled.Label>
      </Styled.FoldersListAction>
      <Styled.SettingsMenuAction
        screenReaderOnlyText="Folder Settings"
        size="small"
        disableHoverAnimation
        onClick={toggleFolderSettings}
        data-test="folder-settings-button"
      >
        <Styled.GearIcon />
      </Styled.SettingsMenuAction>
      {isFolderSettingsVisible && (
        <Styled.FolderSettingsMenu closeMenu={closeFolderSettings} index={index} />
      )}
    </Styled.FoldersListItem>
  )
}

const mapStateToProps = (state: AppState, ownProps) => ({
  isSelected: isFolderSelectedSelector(state, ownProps),
})

const mapDispatchToProps = {
  listFolderProjects: fetchFolderProjects,
  updateSelection: setFolderId,
  setProjectFilter,
}

export default connect(mapStateToProps, mapDispatchToProps)(FoldersListItem)
